import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import { API_LOCATION } from '@/api-config'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetAiPrompt',
  props: {
    dashboardId: null
  },
  emits: ["generated", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'generated', payload: { config: any; unresolved: string[] }): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  dashboardId: string | number
}





const prompt = ref('')
const loading = ref(false)
const error = ref('')
const hint = ref('')

async function getToken(): Promise<string> {
  const session = await Auth.currentSession()
  return session.getIdToken().getJwtToken()
}

async function generate() {
  if (loading.value || !prompt.value.trim()) return
  loading.value = true
  error.value = ''
  hint.value = ''
  try {
    const token = await getToken()
    const companyId = localStorage.getItem('companyId')
    const companyGroupId = JSON.parse(localStorage.getItem('group') as string).id
    const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/dashboards/${props.dashboardId}/widgets/generate`
    const res = await axios.post(url, { prompt: prompt.value.trim() }, { headers: { Authorization: token } })

    const config = res.data?.config
    const unresolved: string[] = res.data?.unresolved || []
    if (!config) {
      error.value = res.data?.message || 'Could not interpret that. Try rephrasing.'
      return
    }
    if (unresolved.length) {
      hint.value = 'Filled in what I could. Double-check the fields below before saving.'
    }
    emit('generated', { config, unresolved })
  } catch (err: any) {
    // New lambdas return JSON errors; fall back to a plain string.
    let msg = 'Something went wrong. Please try again.'
    const data = err?.response?.data
    if (data) {
      try { msg = (typeof data === 'string' ? JSON.parse(data) : data).error || msg } catch { if (typeof data === 'string') msg = data }
    }
    if (err?.response?.status === 429) msg = 'Daily AI limit reached. Please try again tomorrow.'
    error.value = msg
  } finally {
    loading.value = false
  }
}

return { __sfc: true,props, emit, prompt, loading, error, hint, getToken, generate }
}

})